import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onPlanEnded } from "../../utils/planEnded";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

function ProtectComponent(props) {
  const [isLogedIn, setIsLogedIn] = useState(false);
  const navigate = useNavigate();

  const isBillingDateDue = (nextBillingDate) => {
    const nextBillingDateObj = new Date(nextBillingDate);
    const currentDate = new Date();
    if (nextBillingDateObj < currentDate) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    /**
     *
     * Verify whether the token and the user exist.
     * If the user does not exist and the token exists, we will move to <Login />.
     * If the token is valid, the user will be added to localStorage. That is,
     * as long as the token exists and is valid, the user will exist and be valid.
     *
     */
    if (!token || !user) {
      navigate("/");
      return;
    }

    let parsedUser = null;
    // I use try and catch because if user is not valide json type an error will be thrown
    try {
      parsedUser = JSON.parse(user);
    } catch (error) {
      navigate("/");
      return;
    }

    // Pending/rejected accounts have no billing data yet (they haven't been
    // approved) — route them to the review-status page before the billing
    // checks below, which assume an approved account. Guarded so old cached
    // sessions without this field (pre-existing users, unaffected by this
    // gate) fall straight through to the checks below as before.
    if (
      !props.doNotCheckApproval &&
      parsedUser.approval_status &&
      parsedUser.approval_status !== "approved"
    ) {
      navigate("/pendingApproval");
      return;
    }

    const userNextBillingDate = parsedUser.next_billing_date;

    /**
     *
     * I check that the nex_billing_date key exists.
     * If someone changes or deletes the next_billing_date key in user in localStorage,
     * I have to redirect it to <Login /> and if the token exists and is valid,
     * valid user data will be entered in localStorage.
     *
     */
    if (!props.doNotCheckApproval && !userNextBillingDate) {
      navigate("/");
      return;
    }

    if (
      !props.doNotCheckMonthlyPayment &&
      userNextBillingDate &&
      isBillingDateDue(userNextBillingDate)
    ) {
      onPlanEnded(navigate);
      return;
    }

    setIsLogedIn(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isLogedIn ? props.children : <LoadingSpinner />;
}

export default ProtectComponent;
